export const UPDATE_USER_NAME_LOGIN = "UPDATE_USER_NAME_LOGIN"
export const UPDATE_GRT_CREDIT_BY_USER = "UPDATE_GRT_CREDIT_BY_USER"